import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const ContactCTA = () => {
  const { t } = useTranslation();

  return (
    <section className="relative overflow-hidden bg-blueDark py-24 tablet:py-20 px-6 mobile:px-4">
      <div
        className="absolute inset-0 bg-grid opacity-40 [mask-image:radial-gradient(ellipse_at_center,#000_20%,transparent_70%)]"
        aria-hidden="true"
      ></div>
      <div
        className="absolute -bottom-40 left-1/2 -translate-x-1/2 w-[40rem] h-[40rem] rounded-full bg-textBlue/25 blur-[120px]"
        aria-hidden="true"
      ></div>

      <div className="relative container-page">
        <div className="max-w-3xl text-white">
          <h2 className="text-4xl tablet:text-3xl mobile:text-2xl font-semibold tracking-[-0.02em] mb-5">
            {t("cta.title")}
          </h2>
          <p className="text-lg tablet:text-base text-white/80 leading-relaxed mb-8 max-w-[60ch]">
            {t("cta.description")}
          </p>
          <Link
            to="/contact"
            className="group inline-flex items-center gap-2 bg-bgYellow text-black text-sm font-semibold px-7 py-3.5 rounded-full hover:bg-[#dca32f] transition-colors no-underline focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-blueDark"
          >
            {t("cta.button")}
            <ArrowRight
              className="w-4 h-4 transition-transform duration-200 group-hover:translate-x-0.5"
              aria-hidden="true"
            />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ContactCTA;
